module.exports = __webpack_public_path__ + "img/impact.b834e253.svg";